export type SmartCreateData = {
  frn: string;
  firstName: string;
  lastName: string;
  email: string;
  website: string;
  trialEndDate: Date | null;
  companyName: string | null;
  companyNumber: string | null;
  registeredAddress: string | null;
  activeDirectors: string[];
  signatoryPosition: string | null;
  createdCompanyId: string | null;
  envelopeId: string | null;
};

export const initialSmartCreateData: SmartCreateData = {
  frn: '',
  firstName: '',
  lastName: '',
  email: '',
  website: '',
  trialEndDate: null,
  companyName: null,
  companyNumber: null,
  registeredAddress: null,
  activeDirectors: [],
  signatoryPosition: null,
  createdCompanyId: null,
  envelopeId: null,
};
